"use client";

import React, { useEffect, useMemo, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { checkerArray } from "@/utilities/checker";
import { useRouter } from "next/navigation";
import img from "@/public/assets/images/img.png";
import Reliable from '@/public/assets/images/Reliable.png'
import Trusted from '@/public/assets/images/Trusted.png'

import {
  Autoplay,
  Navigation,
  FreeMode,
  Scrollbar,
  A11y,
  Pagination,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { axiosGetOverallProductRatings, axiosGetWishlist, AxiosPost } from "@/utilities/axioscall";
import { AK } from "@/constants";
import toast from "react-hot-toast";
import FadeLoader from "react-spinners/FadeLoader";
import SvgIcons from "@/components/themes/SvgIcons";
import { Star } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { getAssetsBaseUrl, getCurrencySymbol } from "@/services/storeService";
import Baby1svg from "@/public/assets/images/home/baby1.svg";
import Baby2svg from "@/public/assets/images/home/baby2.svg";
import Baby3svg from "@/public/assets/images/home/baby3.svg";
import Baby4svg from "@/public/assets/images/home/baby4.svg";
import Baby5svg from "@/public/assets/images/home/baby5.svg";
import Baby6svg from "@/public/assets/images/home/baby6.svg";
import Baby7svg from "@/public/assets/images/home/baby7.svg";
import Baby8svg from "@/public/assets/images/home/baby8.svg";
import bg from "@/public/assets/images/home/bg.png";
import { ChevronLeft, ChevronRight } from 'lucide-react'

import Babygirl from "@/public/assets/images/home/babygirl.svg";
import img1 from "@/public/assets/images/home/one.png";
import img2 from "@/public/assets/images/home/two.png";
import img3 from "@/public/assets/images/home/three.png";

import crol1 from "@/public/assets/images/home/cor1.svg";
import crol2 from "@/public/assets/images/home/cor2.svg";
import crol3 from "@/public/assets/images/home/cor3.svg";
import crol5 from "@/public/assets/images/home/cor5.svg";
import crol6 from "@/public/assets/images/home/cor6.svg";
import crol7 from "@/public/assets/images/home/cor7.svg";

import cor1 from "@/public/assets/images/home/cor1.png";
import cor2 from "@/public/assets/images/home/cor2.png";
import cor3 from "@/public/assets/images/home/cor3.png";
import cor4 from "@/public/assets/images/home/cor4.png";
import cor5 from "@/public/assets/images/home/cor5.png";
import cor6 from "@/public/assets/images/home/cor6.png";
import { addtowishlist } from "@/clicks/wishlistClicks";
import BrowseByCategory from "./BrowseByCategory";


// Animation variants
const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const certifications = [
  { id: 1, image: cor1, alt: "Food Grade Silicone" },
  { id: 2, image: cor2, alt: "Safe for Children" },
  { id: 3, image: cor3, alt: "RoHS Certified" },
  { id: 4, image: cor4, alt: "BPA Free" },
  { id: 5, image: cor5, alt: "Microwave Oven Safe" },
  { id: 6, image: cor6, alt: "Food Safe" },
];


// ========== MAIN HOMEPAGE COMPONENT ==========
const Homepage = ({
  categoryListData,
  featuredcategoriesListData,
  bestsellersListData,
  topratedListData,
}: {
  categoryListData: any;
  featuredcategoriesListData: any;
  bestsellersListData: any;
  topratedListData: any;
}) => {

  console.log(bestsellersListData, 'bestsellersListData')
  const router = useRouter();
  if (!router) return null;

  const assets = `${getAssetsBaseUrl()}`
  const productimage = "";
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [productwishlistData, setproductwishlistData] = useState<any[]>([]);
  const store = process.env.NEXT_PUBLIC_STORE_NAME || "Store";

  const navigate = (moveon: string) => {
    router.push(moveon);
  };

  const viewproductinfo = (product: any) => {
    navigateToDynamicPage(product.seo_url);
  };

  const navigateToDynamicPage = (seoUrl: string) => {
    console.log("Navigating to:", seoUrl);
    router.push(`/p/${seoUrl}`);
  };

  const [formValues, setFormValues] = useState({
    newsemail: "",
    newsemailError: false,
    formloading: false,
  });

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    var error = false;

    if (formValues.newsemail == "") {
      handleChange({
        target: {
          value: true,
          name: "newsemailError",
        },
      });

      error = true;
    } else {
      handleChange({
        target: {
          value: false,
          name: "newsemailError",
        },
      });
    }

    if (error) return;

    console.log(formValues);

    handleChange({
      target: {
        value: true,
        name: "formloading",
      },
    });
    var formdata = {
      email: formValues.newsemail,
    };
    return await AxiosPost(AK.NEWSLETTERFORMAPI, formdata)
      .then((res: any) => {
        if (res != typeof undefined && res.data != typeof undefined) {
          if (res?.data) {
            notify();
            setFormValues({
              newsemail: "",
              newsemailError: false,
              formloading: false,
            });
            handleChange({
              target: {
                value: false,
                name: "formloading",
              },
            });

            return true;
          } else {
            notifyerror("Newsletter validation error.");
          }
        }

        handleChange({
          target: {
            value: false,
            name: "formloading",
          },
        });
        return true;
      })
      .catch((error) => {
        console.log(error);
        handleChange({
          target: {
            value: false,
            name: "formloading",
          },
        });
        return false;
      });
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  const notify = () =>
    toast.success("Newsletter subscribed successfully.", {
      style: {
        border: "1px solid #00b852",
        padding: "16px",
        color: "#00b852",
      },
      iconTheme: {
        primary: "#00b852",
        secondary: "#FFFAEE",
      },
    });

  const notifyerror = (msg: any) =>
    toast.error(msg, {
      style: {
        border: "1px solid #cc0000",
        padding: "16px",
        color: "#cc0000",
      },
      iconTheme: {
        primary: "#cc0000",
        secondary: "#FFFAEE",
      },
    });

  const mainCategories = categoryListData?.filter(
    (category: any) => category.parent_id === 0
  );

  mainCategories?.sort((a: any, b: any) => a.id - b.id);

  const [pageinit, setPageInit] = useState(false);
  const [productoverallratingData, setproductoverallratingData] = useState<any[]>([]);

  useEffect(() => {
    if (!pageinit) {
      setPageInit(true);
      axiosGetOverallProductRatings(setproductoverallratingData);
      axiosGetWishlist(setproductwishlistData);
    }
  }, [pageinit]);

  const getProductRating = (productId: any) => {
    const productRating = productoverallratingData.find(
      (prod) => prod.product_id === productId
    )?.average_rating;

    return productRating ? parseFloat(productRating).toFixed(1) : "0.0";
  };

  const ageCards = [
    // { svg: Baby1svg },
    // { svg: Baby2svg },
    // { svg: Baby3svg },
    // { svg: Baby4svg },
    // { svg: Baby5svg },
    { svg: Baby6svg },
    { svg: Baby8svg },
    { svg: Baby7svg },

  ];

  const MARQUEE_TEXT = "100% TRUSTED & SAFE PRODUCTS - SHOP WITH CONFIDENCE";

  const combos = [
    { title: 'Feeding Trainer - Combo' },
    { title: 'Bath of Joy - Combo' },
    { title: 'Combo - 3' },
    { title: 'Combo - 4' },
    { title: 'Combo - 5' },
    { title: 'Combo - 6' },
  ];

  const badges = [crol1, crol2, crol3, crol5, crol6, crol7];

  const scrollRef = useRef(null);

  const icons = [
    { id: 1, src: crol1, alt: "Food Grade Silicone" },
    { id: 2, src: crol2, alt: "Safe for Children" },
    { id: 3, src: crol3, alt: "RoHS" },
    { id: 5, src: crol5, alt: "BPA Free" },
    { id: 6, src: crol6, alt: "Microwave Oven Safe" },
    { id: 7, src: crol7, alt: "Food Safe" },
  ];

  const testimonials = [
    {
      content: "Excellent build quality and reliable performance. The power unit works flawlessly even under heavy load. Fast delivery and great support. Highly recommended for both home and industrial use.",
      author: "Jayson",
      location: ""
    },
    {
      content: "Stable power output and premium finish. We’ve been using it daily with zero issues. Truly a dependable product that delivers exactly what it promises.",
      author: "Jayson",
      location: ""
    },
    {
      content: "Top-notch electronic power solution. Efficient, durable, and easy to install. It has significantly improved our system performance.",
      author: "Jayson",
      location: ""
    },
    {
      content: "Reliable, powerful, and well-designed. This product exceeded our expectations and runs perfectly even during peak usage.",
      author: "Jayson",
      location: ""
    }
  ]





  const productsUnder499 = useMemo(() => {
    const allProducts: any[] = [];

    // Collect products from categoryListData
    categoryListData?.forEach((category: any) => {
      if (category.products && Array.isArray(category.products)) {
        category.products.forEach((product: any) => {
          if (product.sp < 299) {
            allProducts.push(product);
          }
        });
      }
    });

    // Collect products from featuredcategoriesListData
    featuredcategoriesListData?.forEach((category: any) => {
      if (category.products && Array.isArray(category.products)) {
        category.products.forEach((product: any) => {
          if (product.sp < 299) {
            allProducts.push(product);
          }
        });
      }
    });

    // Collect products from bestsellersListData
    if (bestsellersListData && Array.isArray(bestsellersListData)) {
      bestsellersListData.forEach((product: any) => {
        if (product.sp < 299) {
          allProducts.push(product);
        }
      });
    }

    // Collect products from topratedListData
    if (topratedListData && Array.isArray(topratedListData)) {
      topratedListData.forEach((product: any) => {
        if (product.sp < 299) {
          allProducts.push(product);
        }
      });
    }

    // Remove duplicates based on product id
    const uniqueProducts = allProducts.filter((product, index, self) =>
      index === self.findIndex((p) => p.id === product.id)
    );

    return uniqueProducts;
  }, [categoryListData, featuredcategoriesListData, bestsellersListData, topratedListData]);









  return (<>
    <motion.section
      initial="hidden"
      animate="visible"
      variants={staggerContainer}
    >
      {/* ========== BANNER SECTION ========== */}
      <Swiper
        className="mySwiper2 mt-md-3 mb-1 mt-0"
        modules={[Autoplay]}
        spaceBetween={50}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
      >
        {[
          {
            href: "/products/testing-product",
            desktop:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
            mobile:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
          },
          {
            href: "/products/testing-product",
            desktop:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
            mobile:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
          },
        ].map((banner, index) => (
          <SwiperSlide key={index}>
            <motion.div
              style={{ height: "100%" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <a href={banner.href} className="block w-full relative overflow-hidden">
                <Image
                  src={banner.desktop.trim()}
                  alt="Home Banner - Desktop"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="hidden md:block object-cover w-full h-full"
                  priority
                />

                <Image
                  src={banner.mobile.trim()}
                  alt="Home Banner - Mobile"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="md:hidden object-cover w-full h-full"
                  priority
                />
              </a>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* ========== SHOP BY AGE SECTION ========== */}
      {/* <motion.section
        className="w-full flex flex-col items-center gap-6 bg-[#F7F4FB] py-[40px]"
        variants={staggerContainer}
        whileInView="show"
      >
        <div>
          <p className="text-[40px] text-black text-center font-bold" >Shop by Age</p>
        </div>
        <motion.div
          className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-2 lg:gap-[50px] gap-[20px]"
          variants={fadeIn}
        >
          {ageCards.map((card, index) => (
            <motion.div
              key={index}
              variants={fadeIn}
              whileHover={{ scale: 1.08 }}
              whileTap={{ scale: 0.96 }}
            >
              <a href="/products/baby-products">
                <Image
                  src={card.svg}
                  alt="age-svg"
                  width={160}
                  height={160}
                  className="object-contain"
                />
              </a>
            </motion.div>
          ))}
        </motion.div>
      </motion.section> */}

      <div className="-mt-4 md:-mt-6">
        <BrowseByCategory />
      </div>

      {/* ========== TOP DEALS BY MOMS SECTION ========== */}
      <section className="bg-white relative max-w-7xl mx-auto my-[20px] px-[16px]">
        <center>
          <div className="relative w-fit mb-[25px]">
            <h3 className="pb-4 pt-4 text-[#000000] font-lato text-[32px] font-[900]" >
              Top Deals
            </h3>
          </div>
        </center>

        <div className="relative w-full">
          <button className="swiper-button-prev-topdeals shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m15 18-6-6 6-6" />
            </svg>
          </button>

          <button className="swiper-button-next-topdeals shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>

          <Swiper
            modules={[Autoplay, Navigation]}
            spaceBetween={10}
            slidesPerView={2}
            loop={true}
            navigation={{
              nextEl: '.swiper-button-next-topdeals',
              prevEl: '.swiper-button-prev-topdeals',
            }}
            breakpoints={{
              400: { slidesPerView: 2, spaceBetween: 10 },
              640: { slidesPerView: 3, spaceBetween: 15 },
              768: { slidesPerView: 3, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 25 },
              1280: { slidesPerView: 4, spaceBetween: 30 },
            }}
          >
            {featuredcategoriesListData[0]?.products?.map((product: any) => {
              const imageUrls = product?.imageurl?.split(",") || [];
              const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
              const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

              return (
                <SwiperSlide key={product.id} className="group">
                  <div className="bg-white overflow-hidden cursor-pointer">
                    <div
                      className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                      onClick={() => viewproductinfo(product)}
                      onMouseEnter={() => setHoveredProductId(product.id)}
                      onMouseLeave={() => setHoveredProductId(null)}
                    >
                      <Image
                        src={
                          hoveredProductId === product.id
                            ? `${assets}${productimage}${hoverImage}`
                            : `${assets}${productimage}${defaultImage}`
                        }
                        alt={product.name}
                        fill
                        className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                        onError={(e) => {
                          e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                        }}
                        loading="lazy"
                      />

                      <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                        <svg
                          className="cursor-pointer"
                          onClick={(e) => {
                            e.stopPropagation();
                            addtowishlist(
                              product,
                              productwishlistData,
                              setproductwishlistData,
                              navigate
                            );
                          }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill={
                            productwishlistData?.includes(
                              product?.id?.toString()
                            )
                              ? "#f45440"
                              : "none"
                          }
                        >
                          <path
                            d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                            stroke={
                              productwishlistData?.includes(
                                product?.id?.toString()
                              )
                                ? "#f45440"
                                : "#fff"
                            }
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      {product.mrp !== product.sp && product.mrp > 0 && (
                        <div className="absolute top-[10px] left-0 bg-[#1952E0] text-white text-[14px] font- px-[6px] py-[8px]">
                          {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% Off
                        </div>
                      )}
                    </div>

                    <div className="mt-[16px] space-y-[8px]">
                      <p className="text-[16px] font-medium font-inter text-[#000000]">
                        {product.name}
                      </p>

                      <div className="flex items-center justify-between">
                        <div className="flex items-center justify-center gap-2">
                          <p className="text-[18px] font-bold text-[#000000]">
                            Rs.{product.sp}
                          </p>
                          {product.mrp !== product.sp && (
                            <p className="text-[16px] text-[#000000]/50 line-through">
                              Rs.{product.mrp}
                            </p>
                          )}
                        </div>
                        <div className="flex items-center gap-1">
                          <SvgIcons.ProduectStar />
                          <p className="text-[16px]">4.5 Stars</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </section>

      {/* ========== BABY PRODUCTS SECTION (FIRST FEATURED CATEGORY) ========== */}
      {featuredcategoriesListData[0] && (
        <section className="bg-white relative max-w-7xl mx-auto px-[16px] md:py-[40px] py-[20px]">
          <div className="flex items-center justify-between">
            <div className="invisible md:block hidden">
              <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                <button>View All</button>
              </a>
            </div>
            <div className="relative w-fit md:mb-[25px]">
              <h3 className="pb-4 pt-4 text-[#000000] text-[32px] font-[900] font-lato">
                {featuredcategoriesListData[0]?.name}
              </h3>
            </div>
            <div>
              <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                <button className="text-primary border-b border-primary font-medium">View All</button>
              </a>
            </div>
          </div>

          <div className="relative w-full">
            <button className="swiper-button-prev-section0 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m15 18-6-6 6-6" />
              </svg>
            </button>

            <button className="swiper-button-next-section0 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m9 18 6-6-6-6" />
              </svg>
            </button>

            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              navigation={{
                nextEl: '.swiper-button-next-section0',
                prevEl: '.swiper-button-prev-section0',
              }}
              breakpoints={{
                400: { slidesPerView: 2, spaceBetween: 10 },
                640: { slidesPerView: 3, spaceBetween: 15 },
                768: { slidesPerView: 3, spaceBetween: 20 },
                1024: { slidesPerView: 4, spaceBetween: 25 },
                1280: { slidesPerView: 4, spaceBetween: 30 },
              }}
            >
              {featuredcategoriesListData[0]?.products?.map((product: any) => {
                const imageUrls = product?.imageurl?.split(",") || [];
                const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                return (
                  <SwiperSlide key={product.id} className="group">
                    <div className="bg-white overflow-hidden cursor-pointer">
                      <div
                        className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                        onClick={() => viewproductinfo(product)}
                        onMouseEnter={() => setHoveredProductId(product.id)}
                        onMouseLeave={() => setHoveredProductId(null)}
                      >
                        <Image
                          src={
                            hoveredProductId === product.id
                              ? `${assets}${productimage}${hoverImage}`
                              : `${assets}${productimage}${defaultImage}`
                          }
                          alt={product.name}
                          fill
                          className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                          onError={(e) => {
                            e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                          }}
                          loading="lazy"
                        />

                        <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                          <svg
                            className="cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              addtowishlist(
                                product,
                                productwishlistData,
                                setproductwishlistData,
                                navigate
                              );
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill={
                              productwishlistData?.includes(
                                product?.id?.toString()
                              )
                                ? "#f45440"
                                : "none"
                            }
                          >
                            <path
                              d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                              stroke={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "#fff"
                              }
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>

                        {product.mrp !== product.sp && product.mrp > 0 && (
                          <div className="absolute top-[10px] left-0 bg-[#1952E0] text-white text-[14px] font- px-[6px] py-[8px]">
                            {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% Off
                          </div>
                        )}
                      </div>

                      <div className="mt-[16px] space-y-[8px]">
                        <p className="text-[16px] font-medium font-inter text-[#000000]">
                          {product.name}
                        </p>

                        <div className="flex items-center justify-between">
                          <div className="flex items-center justify-center gap-2">
                            <p className="text-lg font-bold text-[#000000]">
                              Rs.{product.sp}
                            </p>
                            {product.mrp !== product.sp && (
                              <p className="text-[16px] font-bold text-[#000000]/50 line-through">
                                Rs.{product.mrp}
                              </p>
                            )}
                          </div>
                          <div className="flex items-center gap-1">
                            <SvgIcons.ProduectStar />
                            <p className="text-[16px]">4.5 Stars</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </section>
      )}

      {/* ========== MARQUEE SECTION ========== */}
      <div className="w-full bg-[rgba(26,58,138,0.24)] py-4 overflow-hidden">
        <div className="relative flex overflow-x-hidden py-2">
          <div className="animate-marquee whitespace-nowrap flex items-center" >
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8" >
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8" >
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8" >
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8" >
              {MARQUEE_TEXT}
            </span>
          </div>
          <div className="absolute top-0 animate-marquee2 whitespace-nowrap flex items-center">
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8">
              {MARQUEE_TEXT}
            </span>
            <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-[rgba(26,58,138,0.48)] mx-8">
              {MARQUEE_TEXT}
            </span>
          </div>
        </div>
      </div>

      {/* ========== COMBO SECTION ========== */}
      {/* <div className="w-full bg-[#FFFFFF] py-12 px-4 max-w-7xl mx-auto my-[20px]">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-10 lg:gap-12">
            {combos.map((combo, index) => (
              <div
                key={index}
                className="flex justify-center items-center"
              >
                <div className="group relative md:w-[170px] w-[150px] md:h-[170px] h-[150px] cursor-pointer">
                  <div className="absolute inset-0 rounded-full overflow-hidden shadow-lg transition-all duration-500 ease-in-out group-hover:scale-110 group-hover:shadow-2xl">
                    <div className="absolute inset-0">
                      <Image
                        src={bg}
                        alt="Background"
                        fill
                        className="object-cover transition-all duration-500 group-hover:scale-110"
                      />
                    </div>
                    <div className="absolute inset-0 bg-white/50 group-hover:bg-white/40 transition-all duration-500"></div>
                  </div>

                  <div className="absolute inset-0 flex items-center justify-center p-6">
                    <h3 className="text-center text-[20px] font-semibold text-[#2C0B47] transition-all duration-500 group-hover:scale-105 group-hover:text-primary z-10">
                      {combo.title}
                    </h3>
                  </div>

                  <div className="absolute inset-0 rounded-full border-2 border-transparent group-hover:border-pink-300 transition-all duration-500 scale-95 group-hover:scale-105 opacity-0 group-hover:opacity-100"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}


      {/* ========== Women Essentials SECTION (FIRST FEATURED CATEGORY) ========== */}
      {featuredcategoriesListData[0] && (
        <section className="bg-[#FAF8FC] md:pb-[60px] pb-[30px] px-[16px] md:py-[40px] py-[20px]">
          <div className="bg-[#FAF8FC] relative max-w-7xl mx-auto ">
            <div className="flex items-center justify-between">
              <div className="invisible md:block hidden">
                <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                  <button>View All</button>
                </a>
              </div>
              <div className="relative w-fit md:mb-[25px]">
                <h3 className="pb-4 pt-4 text-[#000000] text-[32px] font-[900] font-lato">
                  {/* {featuredcategoriesListData[0]?.name} */}
                  Solar Power
                </h3>
              </div>
              <div>
                <a href={`/products/${featuredcategoriesListData[0]?.seo_url}`}>
                  <button className="text-primary border-b border-primary font-medium">View All</button>
                </a>
              </div>
            </div>

            <div className="relative w-full">
              <button className="swiper-button-prev-section0 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>

              <button className="swiper-button-next-section0 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>

              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                loop={true}
                navigation={{
                  nextEl: '.swiper-button-next-section0',
                  prevEl: '.swiper-button-prev-section0',
                }}
                breakpoints={{
                  400: { slidesPerView: 2, spaceBetween: 10 },
                  640: { slidesPerView: 3, spaceBetween: 15 },
                  768: { slidesPerView: 3, spaceBetween: 20 },
                  1024: { slidesPerView: 4, spaceBetween: 25 },
                  1280: { slidesPerView: 4, spaceBetween: 30 },
                }}
              >
                {featuredcategoriesListData[0]?.products?.map((product: any) => {
                  const imageUrls = product?.imageurl?.split(",") || [];
                  const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                  const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                  return (
                    <SwiperSlide key={product.id} className="group">
                      <div className=" overflow-hidden cursor-pointer">
                        <div
                          className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                          onClick={() => viewproductinfo(product)}
                          onMouseEnter={() => setHoveredProductId(product.id)}
                          onMouseLeave={() => setHoveredProductId(null)}
                        >
                          {/* <Image
                            src={
                              hoveredProductId === product.id
                                ? `${assets}${productimage}${hoverImage}`
                                : `${assets}${productimage}${defaultImage}`
                            }
                            alt={product.name}
                            fill
                            className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                            onError={(e) => {
                              e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                            }}
                            loading="lazy"
                          /> */}

                          <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                            <svg
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                );
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke={
                                  productwishlistData?.includes(
                                    product?.id?.toString()
                                  )
                                    ? "#f45440"
                                    : "#fff"
                                }
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          {product.mrp !== product.sp && product.mrp > 0 && (
                            <div className="absolute top-[10px] left-0 bg-[#1952E0] text-white text-[14px] font- px-[6px] py-[8px]">
                              {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% Off
                            </div>
                          )}
                        </div>

                        <div className="mt-[16px] space-y-[8px]">
                          <p className="text-[16px] font-medium font-inter text-[#000000]">
                            {product.name}
                          </p>

                          <div className="flex items-center justify-between">
                            <div className="flex items-center justify-center gap-2">
                              <p className="text-[18px] font-bold text-[#000000]">
                                Rs.{product.sp}
                              </p>
                              {product.mrp !== product.sp && (
                                <p className="text-[16px] text-[#000000]/50 line-through">
                                  Rs.{product.mrp}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              <SvgIcons.ProduectStar />
                              <p className="text-[16px]">4.5 Stars</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </section>
      )}

      {/* ========== BANNER IMAGE ========== */}
      <div>
        <div>
          {/* <a href="/products/baby-products">
            <img
              src="https://assetsvilva.blr1.cdn.digitaloceanspaces.com/BO21H1191224/uploads/VHydpqRL9N6g7eVGCJ9AnHdO8uDWIZbJAqVsezbE.webp" alt="" />
          </a> */}
        </div>
      </div>

      <Swiper
        className="mySwiper2 mt-md-3 mb-1 mt-0"
        modules={[Autoplay]}
        spaceBetween={50}
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 4500,
          disableOnInteraction: false,
        }}
      >
        {[
          {
            href: "/products/baby-products",
            desktop:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
            mobile:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
          },
          {
            href: "/products/baby-products",
            desktop:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
            mobile:
              " https://assetsvilva.blr1.cdn.digitaloceanspaces.com/ecomsaas/redisapi/FA0354ZB1812/uploads/Qii71cGuhh8GF8UDr1WFi3HCfL6j9ky18Xb8szWs.webp",
          },
        ].map((banner, index) => (
          <SwiperSlide key={index}>
            <motion.div
              style={{ height: "100%" }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <a href={banner.href} className="block w-full relative overflow-hidden">
                <Image
                  src={banner.desktop.trim()}
                  alt="Home Banner - Desktop"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="hidden md:block object-cover w-full h-full"
                  priority
                />

                <Image
                  src={banner.mobile.trim()}
                  alt="Home Banner - Mobile"
                  width={1920}
                  height={1080}
                  quality={75}
                  sizes="100vw"
                  className="md:hidden object-cover w-full h-full"
                  priority
                />
              </a>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* ========== BABY PRODUCTS SECTION (FIRST FEATURED CATEGORY) ========== */}
      {productsUnder499.length > 0 && (
        <section className="bg-[#FAF8FC] md:pb-[60px] pb-[30px] px-[16px] md:py-[40px] py-[20px]">
          <div className="bg-[#FAF8FC] relative max-w-7xl mx-auto">
            <div className="flex items-center justify-between">
              <div className="invisible md:block hidden">
                <button>View All</button>
              </div>
              <div className="relative w-fit md:mb-[25px]">
                <h3 className="pb-4 pt-4 text-[#000000] text-[32px] font-[900] font-lato" >
                  Home Automation
                </h3>
              </div>
              <div>
                <button className="text-primary border-b border-primary font-medium">View All</button>
              </div>
            </div>

            <div className="relative w-full">
              <button className="swiper-button-prev-under499 shadow-md !absolute left-2 top-1/2 -translate-y-1/2 z-10 w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>

              <button className="swiper-button-next-under499 shadow-md !absolute right-2 top-1/2 -translate-y-1/2 z-10 !w-9 h-9 bg-white text-black rounded-full flex items-center justify-center hover:bg-white/80 transition-all hover:scale-110 active:scale-95">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>

              <Swiper
                modules={[Autoplay, Navigation]}
                spaceBetween={10}
                slidesPerView={2}
                loop={productsUnder499.length > 4}
                navigation={{
                  nextEl: '.swiper-button-next-under499',
                  prevEl: '.swiper-button-prev-under499',
                }}
                breakpoints={{
                  400: { slidesPerView: 2, spaceBetween: 10 },
                  640: { slidesPerView: 3, spaceBetween: 15 },
                  768: { slidesPerView: 3, spaceBetween: 20 },
                  1024: { slidesPerView: 4, spaceBetween: 25 },
                  1280: { slidesPerView: 4, spaceBetween: 30 },
                }}
              >
                {productsUnder499.map((product: any) => {
                  const imageUrls = product?.imageurl?.split(",") || [];
                  const defaultImage = checkerArray(imageUrls, 1) ? imageUrls[0].trim() : "";
                  const hoverImage = checkerArray(imageUrls, 2) ? imageUrls[1].trim() : defaultImage;

                  return (
                    <SwiperSlide key={product.id} className="group">
                      <div className="overflow-hidden cursor-pointer">
                        <div
                          className="relative overflow-hidden rounded-[8px] w-full lg:h-[328px] md:h-[258px] h-[200px] object-cover"
                          onClick={() => viewproductinfo(product)}
                          onMouseEnter={() => setHoveredProductId(product.id)}
                          onMouseLeave={() => setHoveredProductId(null)}
                        >
                          <Image
                            src={
                              hoveredProductId === product.id
                                ? `${assets}${productimage}${hoverImage}`
                                : `${assets}${productimage}${defaultImage}`
                            }
                            alt={product.name}
                            fill
                            className="rounded-[8px] object-cover transition-transform duration-500 ease-in-out hover:scale-110 border-2 border-gray-100"
                            onError={(e) => {
                              e.currentTarget.src = "/ecomsaas-assets/images/no-image.webp";
                            }}
                            loading="lazy"
                          />

                          <div className="absolute bottom-2 right-2 bg-black/20 p-2 rounded-full">
                            <svg
                              className="cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                addtowishlist(
                                  product,
                                  productwishlistData,
                                  setproductwishlistData,
                                  navigate
                                );
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill={
                                productwishlistData?.includes(
                                  product?.id?.toString()
                                )
                                  ? "#f45440"
                                  : "none"
                              }
                            >
                              <path
                                d="M15.8333 11.9202C17.075 10.7035 18.3333 9.24521 18.3333 7.33687C18.3333 6.1213 17.8504 4.95551 16.9909 4.09597C16.1314 3.23643 14.9656 2.75354 13.75 2.75354C12.2833 2.75354 11.25 3.17021 9.99999 4.42021C8.74999 3.17021 7.71666 2.75354 6.24999 2.75354C5.03441 2.75354 3.86863 3.23643 3.00908 4.09597C2.14954 4.95551 1.66666 6.1213 1.66666 7.33687C1.66666 9.25354 2.91666 10.7119 4.16666 11.9202L9.99999 17.7535L15.8333 11.9202Z"
                                stroke={
                                  productwishlistData?.includes(
                                    product?.id?.toString()
                                  )
                                    ? "#f45440"
                                    : "#fff"
                                }
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>

                          {product.mrp !== product.sp && product.mrp > 0 && (
                            <div className="absolute top-[10px] left-0 bg-[#1952E0] text-white text-[14px] font- px-[6px] py-[8px]">
                              {(((product.mrp - product.sp) / product.mrp) * 100).toFixed(0)}% Off
                            </div>
                          )}
                        </div>

                        <div className="mt-[16px] space-y-[8px]">
                          <p className="text-[16px] font-medium font-inter text-[#000000]">
                            {product.name}
                          </p>

                          <div className="flex items-center justify-between">
                            <div className="flex items-center justify-center gap-2">
                              <p className="text-[18px] font-bold text-[#000000]">
                                Rs.{product.sp}
                              </p>
                              {product.mrp !== product.sp && (
                                <p className="text-[16px] text-[#000000]/50 line-through">
                                  Rs.{product.mrp}
                                </p>
                              )}
                            </div>
                            <div className="flex items-center gap-1">
                              <SvgIcons.ProduectStar />
                              <p className="text-[16px]">4.5 Stars</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>
          </div>
        </section>
      )}

      <div className=" bg-[#E5E9F7]">
        {/* Hero Section */}
        <section className="container mx-auto px-4 py-8 md:py-12 lg:py-[29px]">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center max-w-[1620px] mx-auto">
            {/* Left side - Illustration */}
            <div className="flex justify-center lg:justify-start order-2 lg:order-1">
              <Image
                src={Reliable}
                alt="Electrical and power systems illustration showing solar panels, power lines, security camera, and smart home technology"
                className="w-full max-w-[602px] h-auto"
                width={602}
                height={536}
              />
            </div>

            {/* Right side - Content */}
            <div className="order-1 lg:order-2 space-y-6 md:space-y-10">
              <h1 className="text-[#1A3A8A] font-bold font-inter text-4xl sm:text-5xl md:text-[69px] lg:text-[69.559px] leading-[120%]">
                Reliable Electrical &amp; Power Solutions
              </h1>

              <p className="text-[#565859] font-normal text-lg sm:text-xl md:text-[28px] lg:text-[28px] !leading-[40px] max-w-[689px]">
                Design, install, and maintain commercial and industrial power
                systems with unmatched expertise.
              </p>

              {/* Feature badges */}
              <div className=" ">
                <Image
                  src={Trusted}
                  alt="Feature badges showing Trusted Solutions with handshake icon, Fast Support with lightning icon, and Expert Assistance with wrench icon"
                  className="w-full max-w-[692px] h-auto"
                  width={692}
                  height={200}
                />
              </div>
            </div>
          </div>
        </section>
      </div>



      {/* ========== TESTIMONIALS SECTION ========== */}
      <section className="py-16 px-4 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="md:text-[32px] text-[28px] font-[600] font-lato text-center md:mb-12 mb-6 text-black" >
            Customer Reviews
          </h2>

          <div className="relative">
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={24}
              slidesPerView={1}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              navigation={{
                prevEl: '.swiper-button-prev-custom',
                nextEl: '.swiper-button-next-custom'
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 24
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 24
                }
              }}
              className="pb-12"
            >
              {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="w-fit h-fit flex flex-col p-[32px] rounded-[40px] border-[2px] space-y-[24px]"
                    style={{
                      borderColor: "rgba(33, 0, 64, 0.05)",
                      background: "radial-gradient(90.52% 90.52% at 50% 9.48%, #FFF 0%, #DBE1F2 100%",
                    }}
                  >
                    <p className="text-[#000000] text-[16px] font-normal leading-relaxed">
                      "{testimonial.content}"
                    </p>

                    <p className="text-[#000000] text-[16px] font-medium text-center md:text-base">
                      - {testimonial.author} {testimonial.location}
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="flex space-x-2 mt-[10px] mx-auto md:justify-start justify-center">
              <button
                className="swiper-button-prev-custom bg-white p-[2px] rounded-full shadow-md"
                aria-label="Previous testimonial"
              >
                <ChevronLeft className="w-6 h-6 text-gray-700" />
              </button>

              <button
                className="swiper-button-next-custom bg-white p-[2px] rounded-full shadow-md"
              >
                <ChevronRight className="w-6 h-6 text-gray-700" />
              </button>
            </div>
          </div>
        </div>
      </section>

    </motion.section>
  </>)
};

export default Homepage;
